import { takeLatest } from 'redux-saga/effects';
import loadEnrolUserSaga from './loadEnrolUserSaga';
import { LOAD_ENROL_USER_SAGA } from '../../../../reducers/enrolUser.reducer';

function* root() {
  yield takeLatest(LOAD_ENROL_USER_SAGA, loadEnrolUserSaga);
}

export default root;
